export interface ButtonAccessConfig {
    label: string;
    code: string;
  }
  
  export const AccessConfig = {
    CREDIT_TAX_INVOICE: {
      label: 'Credit Tax Invoice Printing',
      code: 'SAT_MT_CN_OPT_CRTAXINV'
    },
    DEBIT_TAX_INVOICE: {
      label: 'Debit Tax Invoice Printing',
      code: 'SAT_MT_CN_OPT_DBTAXINV'
    },
    TAX_INVOICE: {
      label: 'Tax Invoice Printing',
      code: 'SAT_MT_CN_OPT_TAXINV'
    },
    AMEND_COVER_NOTE: {
      label: 'Amend Open Dated Cover Note',
      code: 'SAT_MT_OPT_AMEND_CN'
    },
    CANCEL_COVER_NOTE: {
      label: 'Cancel Cover Note',
      code: 'SAT_MT_OPT_CANCEL'
    },
    CANCEL_ENDORSEMENT: {
      label: 'Cancel Endorsement',
      code: 'SAT_MT_OPT_ENDT_CANCEL'
    },
    ENDORSEMENT_PDF: {
      label: 'Endorsement PDF Printing',
      code: 'SAT_MT_OPT_ENDT_PDF'
    },
    ENDORSEMENT_PDF_CERTIFICATE: {
      label: 'Endorsement PDF Certificate Printing',
      code: 'SAT_MT_OPT_ENDT_PDF_CE'
    },
    ENDORSEMENT_PDF_CONFIRMATION: {
      label: 'Endorsement PDF Confirmation Slip Printing',
      code: 'SAT_MT_OPT_ENDT_PDF_CS'
    },
    ENDORSEMENT_PDF_SCHEDULE: {
      label: 'Endorsement PDF Schedule Printing',
      code: 'SAT_MT_OPT_ENDT_PDF_SC'
    },
    VIEW_ENDORSEMENT: {
      label: 'View Endorsement',
      code: 'SAT_MT_OPT_ENDT_VIEW'
    },
    APPROVED_COVER_NOTE: {
      label: 'Approved Cover Note',
      code: 'SAT_MT_OPT_ISS_APPR_CN'
    },
    COVER_NOTE_PDF: {
      label: 'Cover Note PDF Printing',
      code: 'SAT_MT_OPT_PDF'
    },
    REPRINT_COVER_NOTE: {
      label: 'Reprint Cover Note PDF Printing',
      code: 'SAT_MT_OPT_REPRINT_PDF'
    },
    VIEW_UPDATE_JPJ: {
      label: 'View/Update JPJ Details',
      code: 'SAT_MT_OPT_UPD_JPJ'
    },
    UPDATE_PAYMENT: {
      label: 'Update Payment',
      code: 'SAT_MT_OPT_UPD_PYMT'
    },
    VIEW_COVER_NOTE: {
      label: 'View Cover Note',
      code: 'SAT_MT_OPT_VIEW'
    },
    CANCEL_QUOTATION: {
      label: 'Cancel Quotation',
      code: 'SAT_MT_QT_OPT_CANCEL'
    },
    QUOTATION_PDF: {
      label: 'Quotation PDF Printing',
      code: 'SAT_MT_QT_OPT_PDF'
    },
    UPDATE_QUOTATION: {
      label: 'Update Quotation',
      code: 'SAT_MT_QT_OPT_UPD'
    },
    VIEW_QUOTATION: {
      label: 'View Quotation',
      code: 'SAT_MT_QT_OPT_VIEW'
    },
    SEND_TO_JPJ: {
      label: 'Send To JPJ',
      code: 'SAT_MT_OPT_ISS_CN'
    }
  }  as const;
  